import React, { useEffect, useState } from "react";

/**
 * Vertical text tag that runs down the far-left edge of the page.
 * Contained inside a fixed 56px column so the rotated content never
 * bleeds into page content — solves the "text sits in the middle" bug.
 */
export default function VerticalTag({ text = "The White Project Co · Sydney" }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 250);
    return () => clearTimeout(t);
  }, []);
  return (
    <div
      aria-hidden
      data-testid="vertical-tag"
      className="hidden md:flex fixed left-0 top-0 bottom-0 w-14 z-20 items-center justify-center pointer-events-none select-none"
      style={{ opacity: visible ? 1 : 0, transition: "opacity 800ms cubic-bezier(0.16,1,0.3,1)" }}
    >
      <div
        className="flex items-center gap-4 whitespace-nowrap"
        style={{ transform: "rotate(-90deg)", transformOrigin: "center center" }}
      >
        <span className="inline-block w-8 border-t border-ink/25" />
        <span className="mono-label text-ash/70">{text}</span>
        <span className="inline-block w-8 border-t border-ink/25" />
      </div>
    </div>
  );
}
